(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-recommendation-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  refreshRelatedProducts();

  // Listen for cart interactions
  document.body.addEventListener('click', (e) => {
    if (
      e.target.matches('[data-remove-item], .cart__remove, .quantity__button') ||
      e.target.closest('[data-remove-item], .cart__remove, .quantity__button')
    ) {
      setTimeout(refreshRelatedProducts, 500);
    }
  });

  document.addEventListener('cart:updated', () => setTimeout(refreshRelatedProducts, 100));
  document.addEventListener('cart-drawer:updated', refreshRelatedProducts);
});

// Fetch and render related products
async function refreshRelatedProducts() {
  const relatedSection = document.querySelector('[data-cart-related-section]');
  const sliderContainer = document.querySelector('.cart-related-products-slider');
  const cartDrawerInner = document.querySelector('.m-cart-drawer__inner');

  if (!relatedSection || !sliderContainer) return;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    if (cart.item_count === 0) {
      relatedSection.style.display = 'none';
      cartDrawerInner?.classList.add('no-related-products');
      sliderContainer.innerHTML = '';
      return;
    } else {
      relatedSection.style.display = 'flex';
      cartDrawerInner?.classList.remove('no-related-products');
    }

    // Get unique collection handles from cart items
    const collectionHandles = new Set();
    
    for (const item of cart.items) {
      // Try to extract collection from product URL or use a recommendations endpoint
      const productResponse = await fetch(`/products/${item.handle}.js`);
      const productData = await productResponse.json();
      
      // Get collections from product tags or use search
      if (productData.tags && productData.tags.length > 0) {
        // Use first tag as collection search term
        collectionHandles.add(productData.type || productData.tags[0]);
      }
    }

    // Fetch related products using search or recommendations API
    const shownProductIds = new Set(cart.items.map(i => i.product_id));
    const relatedProducts = [];

    // Use Shopify's product recommendations API
    for (const item of cart.items) {
      if (relatedProducts.length >= 8) break;
      
      try {
        const recResponse = await fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=8`);
        const recData = await recResponse.json();
        
        if (recData.products) {
          for (const product of recData.products) {
            if (relatedProducts.length >= 8) break;
            if (!shownProductIds.has(product.id)) {
              relatedProducts.push(product);
              shownProductIds.add(product.id);
            }
          }
        }
      } catch (err) {
        console.log('Recommendations not available for product:', item.product_id);
      }
    }

    // Render products
    sliderContainer.innerHTML = '';
    
    if (relatedProducts.length === 0) {
      sliderContainer.innerHTML = `<div class="no-related-products"><p>No related products available</p></div>`;
      return;
    }

    relatedProducts.forEach(product => {
      const imageUrl = product.featured_image 
        ? product.featured_image.replace(/\.jpg|\.png|\.gif/, '_400x400$&')
        : '';

      const hasComparePrice = product.compare_at_price && product.compare_at_price > product.price;
      
      const card = document.createElement('div');
      card.className = 'related-product-card';
      card.dataset.productId = product.id;

      console.log('product.price', product);
      
      card.innerHTML = `
        <a href="/products/${product.handle}" class="related-product-link">
          <div class="related-product-image">
            ${hasComparePrice ? '<p class="related-sale-label show m-product-card__tag-name m-product-tag m-product-tag--sale m-color-badge-sale">On Sale</p>' : ''}
            ${imageUrl 
              ? `<img src="${imageUrl}" alt="${escapeHtml(product.title)}" loading="lazy" width="400" height="400">` 
              : '<div class="no-image">No image</div>'}
          </div>
          <div class="related-product-info">
            <p class="related-product-title">${escapeHtml(product.title)}</p>
            <p class="related-product-price">${formatMoney(product.price)} 
            ${hasComparePrice ? `<span class="related-product-compare-price">${formatMoney(product.compare_at_price)}</span>` : ''}
            </p>

          </div>
        </a>
      `;
      
      sliderContainer.appendChild(card);
    });

    // Re-enable smooth scroll after content is added
    enableSmoothScroll(sliderContainer);

  } catch (error) {
    console.error('Error fetching related products:', error);
  }
}

// Escape HTML to prevent XSS
function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Format price with currency
function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  // Use Shopify's money format if available
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents);
  }
  return `$${amount}`;
}

// Smooth scroll
function enableSmoothScroll(slider) {
  let scrollTarget = 0;
  let currentScroll = 0;
  let isScrolling = false;

  slider.addEventListener('wheel', evt => {
    evt.preventDefault();
    const maxScroll = slider.scrollHeight - slider.clientHeight;
    scrollTarget += evt.deltaY;
    scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));

    if (!isScrolling) {
      currentScroll = slider.scrollTop;
      isScrolling = true;
      requestAnimationFrame(smoothScroll);
    }
  }, { passive: false });

  function smoothScroll() {
    const diff = scrollTarget - currentScroll;
    currentScroll += diff * 0.15;
    slider.scrollTop = currentScroll;

    if (Math.abs(diff) > 0.5) {
      requestAnimationFrame(smoothScroll);
    } else {
      currentScroll = scrollTarget;
      slider.scrollTop = scrollTarget;
      isScrolling = false;
    }
  }
}
  } catch(e) { console.error(e); }
})();

})();
